import $ from 'jquery';

export default (function () {
  var ODESSA = null;
  var setupPicturesLightbox = function () {
    $(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
      event.preventDefault();
      $(this).ekkoLightbox({
        onContentLoaded: function () {
          if (this._$element.data('picture-id')) {
            var csrftoken = ODESSA.common.getCookie('csrftoken'),
              $target = this._$element;

            $.ajax({
              type: 'PUT',
              url: '/api/family/photo/' + $target.data('picture-id') + '/mark-read/',
              data: 'read=True',
              beforeSend: function (xhr) {
                xhr.setRequestHeader('X-CSRFToken', csrftoken);
              },
              success: function () {
                $target.closest('.photo').find('.badge-new').remove();
              },
            });
          }
        },
      });
    });
  };

  return {
    init: function (ODESSA_callback) {
      ODESSA = ODESSA_callback;
      setupPicturesLightbox();
    },
  };
})();
